<template>
    <div>
        <message-popup :show_message="show_notified_user_popup" :message="notified_user_message" @close-message="show_notified_user_popup=false"></message-popup>
        <v-row>
            <v-col cols="3">
                <v-btn 
                    min-width="100%" 
                    @click="getUserLeadWorkflow"
                >
                    Workflow
                </v-btn>
            </v-col>
        </v-row>
        <v-row>
            <v-col cols="3">
                <v-text-field
                    label="Estado Lead"
                    v-model="lead_state"
                    readonly
                ></v-text-field>
            </v-col>
            <v-col v-for="action in lead_actions" :key="action['text']" cols="3">
                <v-btn 
                    min-width="100%" 
                    @click="doAction(action['action'])"
                >
                    {{ action['text'] }}
                </v-btn>
            </v-col>            
        </v-row>
        <v-row>
            <v-col cols="3">
                <v-text-field
                    label="Estado User"
                    v-model="user_state"
                    readonly
                ></v-text-field>
            </v-col>
            <v-col v-for="action in user_actions" :key="action['text']" cols="3">
                <v-btn 
                    min-width="100%" 
                    @click="doAction(action['action'])"
                >
                    {{ action['text'] }}
                </v-btn>
            </v-col> 
        </v-row>
        <v-row>
            <v-col cols="3">
                <v-text-field
                    label="Estado Formación"
                    v-model="userData.training_status"
                    readonly
                ></v-text-field>
            </v-col>
            
            <v-col cols="3" v-if="userData.training_status != 'DONE_TRAINING'">
                <v-row>
                <v-btn 
                    min-width="100%" 
                    @click="trainingStatusActive()"
                >
                    Preparado para Formación
                </v-btn>
                </v-row>
            </v-col> 
            
        </v-row>
        <v-row v-if="!['ACTIVE','TRIAL'].includes(user_state) && show_notif_button">
            <v-col cols = "3" >
                <app-date-picker
                      aucomplete="off"
                      label="Fecha inicio contrato"
                      v-model="start_trial_date"
                      :rules="[validationRules.dateFormat]"
                      outlined
                    ></app-date-picker>
            </v-col>
            <v-col cols="3">
                <v-row>
                <v-btn 
                    min-width="100%" 
                    @click="activateUserTrial()"
                >
                    Formación Realizada
                </v-btn>
                </v-row>
                <v-row style="color:red">
                    Pulsar este botón notificará al usuario!
                </v-row>
            </v-col> 
            
        </v-row>
        <v-row>
            <v-col cols="3">
                <v-text-field
                    label="A3auto Estado"
                    v-model="a3auto_status"
                    readonly
                />
            </v-col>
        </v-row>
        <v-divider />
        <v-row>
            <v-col cols="11">
                <h2 color="primary" class="mt-6">Profile Default Settings:</h2>
            </v-col>
            <v-col cols="1">
                <v-btn 
                    color="primary"
                    :loading="updating_default_settings"
                    icon 
                    @click="updateProfileDefaultSettings"
                    class="pa-0 ma-0 mt-6"
                >
                    <v-icon large>mdi-content-save</v-icon>
                </v-btn>
            </v-col>
        </v-row>
        <v-row> 
            <!-- Profile Settings -->
            <v-col v-for="setting in default_settings_dict" cols="4" :key="setting['label']">
                <v-row>
                    <v-col cols="1" class="pa-0 ma-0">
                        <v-checkbox
                            v-model="setting['is_enabled']"
                            :hide-details="true"
                            class="pa-0"
                        ></v-checkbox>
                    </v-col>
                    <v-col cols="10" class="pa-0 ma-0">
                        <v-text-field
                            :label="setting['label']"
                            v-model="setting['value']"
                            :hide-details="true"
                            :disabled="!setting['is_enabled']"
                            :title="('title' in setting && setting['title']) || false"
                        ></v-text-field>
                    </v-col>
                    <v-col cols="1" class="pa-0 ma-0"></v-col>
                </v-row>
            </v-col>
        </v-row>
    </div>
</template>

<script>
    import { client,sync_command_dispatcher } from "@/api/client";
    import {ActivateUserTrialCommand} from "../modules/revenue/app/ActivateUserTrialCommand"
    import { mapState, mapGetters, mapActions } from "vuex";
    import { mapFields } from 'vuex-map-fields';
    import { vuexPrefix } from "../store/vuex_utils";
    import { user as api_user } from "@/api/user";
    import MessagePopup from "./MessagePopup.vue"
    import AppDatePicker from '@/components/layout/AppDatePicker.vue';
    export default {
        name:'Debug',
        components: {MessagePopup,AppDatePicker},
        data() {
            return {
                lead_state: '',
                lead_actions: [],
                user_state: '',
                user_actions: [],
                default_settings_dict: {},
                updating_default_settings: false,
                notified_user_message:'',
                show_notified_user_popup:false,
                show_notif_button:true,
                start_trial_date:'',
                validationRules: {
                    dateFormat: v => /^([0-2][0-9]|(3)[0-1])(\/)(((0)[0-9])|((1)[0-2]))(\/)\d{4}$/.test(v) || 'El formato de la fecha no es válido',
                },
                a3auto_status_values: {
                    "NOT_CHECKED": "No chequeado",
                    "VALID": "Válido",
                    "NOT_VALID": "No válido",
                },
                a3auto_status: ''
            }
        },
        computed: {
            ...mapFields('me', ['userData']),
            ...mapFields('me',vuexPrefix('user_data_',['default_settings', ],'userData.')),
            ...mapState(['currentCompany', 'session_information']),
        },
        mounted() {
            let today = new Date();
            let dd = String(today.getDate()).padStart(2, '0');
            let mm = String(today.getMonth() + 1).padStart(2, '0'); //January is 0!
            let yyyy = String(today.getFullYear());
            
            this.start_trial_date = yyyy + '-' + mm + '-' + dd;
            this.a3auto_status = this.a3auto_status_values[this.userData.a3auto_status];
            client.get('settings/get_setting/admin_profile_default_settings_headers/').then(response => {
                this.default_settings_dict = response.data['params'];
                this.setSettingDictValues();
            }).catch(err => {
                console.debug(err);
            });
        },
        methods: {
            ...mapActions({
                setUserData: "me/setUserData",
            }),
            getUserLeadWorkflow() {
                client.get('get_user_lead_workflow/').then(response => {
                    this.lead_state = response.data['lead']['state'];
                    this.user_state = response.data['user']['state'];
                    this.lead_actions = [];
                    if (response.data['lead']['actions']) {
                        this.lead_actions = response.data['lead']['actions'];
                    }
                    this.user_actions = [];
                    if (response.data['user']['actions']) {
                        this.user_actions = response.data['user']['actions'];
                    }
                }).catch(err => {
                    console.debug(err);
                });
            },
            doAction(action) {
                client.post(action).then(() => {
                    this.getUserLeadWorkflow();
                }).catch(err => {
                    console.debug(err);
                });
            },

            updateProfileDefaultSettings() {
                this.updating_default_settings = true;
                let patch_dict = {};
                for (let i in this.default_settings_dict) {
                    if (typeof this.default_settings_dict[i].value == 'string') {
                        let aux = this.default_settings_dict[i].value.split('\\\\');
                        if (aux[0] == '' && aux.length > 1) {
                            aux[0] = '\\';
                        } 
                        this.default_settings_dict[i].value = aux.join('\\');
                    }
                    let splitted_key = i.split("__");
                    if (splitted_key.length > 1) {
                        if (!(splitted_key[0] in patch_dict)) {
                            patch_dict[splitted_key[0]] = {};
                        }
                        patch_dict[splitted_key[0]][splitted_key[1]] = this.default_settings_dict[i];
                    } else {
                        patch_dict[i] = this.default_settings_dict[i];
                    }
                }
                client.patch('update_profile_default_settings/', patch_dict).then(response => {
                    this.user_data_default_settings = response.data['default_settings'];
                    this.updating_default_settings = false;
                }).catch(err => {
                    console.debug(err);
                    this.updating_default_settings = false;
                });
            },
            format_dict(dict) {
                let new_dict = {};
                for (let i in dict) {
                    if (typeof dict[i] === 'string') {
                        new_dict[i] = dict[i];
                    } else if (typeof dict[i] === 'object' && 'value' in dict[i]) {
                        new_dict[i] = dict[i];
                    } else {
                        for (let j in dict[i]) {
                            new_dict[i + '__' + j] = dict[i][j];
                        }
                    }
                }
                return new_dict;
            },
            setSettingDictValues() {
                this.default_settings_dict = this.format_dict(this.default_settings_dict);
                let formatted_user_data_default_settings = this.format_dict(this.user_data_default_settings);
                for (let i in this.default_settings_dict) {
                    if (Object.keys(formatted_user_data_default_settings).includes(i)) {
                        this.default_settings_dict[i].is_enabled = true;
                        this.default_settings_dict[i].value = formatted_user_data_default_settings[i];
                    }
                }
            },
            async trainingStatusActive() {
                let params = {
                    training_status: 'DONE_TRAINING'
                }
                const response = await api_user.setUserInfo(params);
                this.setUserData(response.data.results);
            },
            activateUserTrial(){
                let init_date = this.start_trial_date // yyyy-mm-dd
                let user_id = this.userData.user
                let logged_user= this.session_information.username
                new ActivateUserTrialCommand(sync_command_dispatcher).run(user_id, init_date, logged_user) 
                    .then((response) => {
                        console.log(response)
                        let output = response.output
                        console.log(output)
                        if(output.error==''){
                            this.notified_user_message = 'Usuario activado y notificado con éxito.'
                            this.show_notif_button = false
                        }
                        else{
                            this.notified_user_message = 'ERROR '+ output.error
                        }
                        this.show_notified_user_popup = true
                    })
                    .catch(error => {
                        this.notified_user_message = 'Error activating user:' + error
                        this.show_notified_user_popup = true
                        console.error('Error activating user:', error);
                        });
            }
        }
    }
</script>

<style scoped>
</style>
